import inputIcon from '../themes/high-contrast/extensions/inputIcon.png';
import outputIcon from '../themes/high-contrast/extensions/outputIcon.png';
import displayIcon from '../themes/high-contrast/extensions/displayIcon.png';
import motorIcon from '../themes/high-contrast/extensions/motorIcon.png';
import rfIcon from '../themes/high-contrast/extensions/rfIcon.png';
import serialIcon from '../themes/high-contrast/extensions/serialIcon.png';
import eventIcon from '../themes/high-contrast/extensions/eventIcon.png';

const isKoreanLocale = locale => locale && locale.toLowerCase().startsWith('ko');

export const extreme = (locale = 'en') => `

    <category name="%{BKY_XROBO_INPUT}" id="cate_54b060f8" colour="#42CCFF" secondaryColour="#22C3FF" iconURI="${inputIcon}">
        <label text="${isKoreanLocale(locale) ? '블루투스' : 'Bluetooth'}"></label>
        <block type="xrobo_bluetooth_1"></block>
        <block type="xrobo_bluetooth_2"></block>
        <block type="xrobo_bluetooth_3"></block>

        <label text="${isKoreanLocale(locale) ? 'X 키패드' : 'X Keypad'}"></label>
        <block type="xrobo_sensor_xkey"></block>

        <label text="${isKoreanLocale(locale) ? '적외선센서' : 'Infrared Sensor'}"></label>
        <block type="xrobo_ir_1"></block>
        <block type="xrobo_ir_2">
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">870</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_ir_3"></block>
        <block type="xrobo_ir_4">
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">30</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">870</field>
                </shadow>
            </value>
        </block>

        <label text="${isKoreanLocale(locale) ? '접촉센서' : 'Touch Sensor'}"></label>
        <block type="xrobo_sensor_contact"></block>
        <block type="xrobo_sensor_wait"></block>

        <label text="${isKoreanLocale(locale) ? '조도센서' : 'Light Sensor'}"></label>
        <block type="xrobo_sensor_photo"></block>

        <label text="${isKoreanLocale(locale) ? '소리센서' : 'Sound Sensor'}"></label>
        <block type="xrobo_sensor_sound"></block>
        <block type="xrobo_sensor_sound2">
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">16</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_sensor_sound3"></block>

        <label text="${isKoreanLocale(locale) ? '조이스틱' : 'Joystick'}"></label>
        <block type="xrobo_sensor_joystick"></block>

        <label text="${isKoreanLocale(locale) ? '센서' : 'Sensor'}"></label>
        <block type="xrobo_sensor_1">
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">870</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_sensor_2"></block>
        <block type="xrobo_sensor_3"></block>

        <label text="${isKoreanLocale(locale) ? '코딩모드' : 'Coding Mode'}"></label>
        <block type="xrobo_sensor_coding">
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">15</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">500</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_sensor_coding2">
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">15</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">500</field>
                </shadow>
            </value>
            <value name="ARG4">
                <shadow type="math_number">
                    <field name="NUM">350</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_sensor_school"></block>

        <label text="${isKoreanLocale(locale) ? '자이로센서' : 'Gyro Sensor'}"></label>
        <block type="xrobo_sensor_gyro1"></block>
        <block type="xrobo_sensor_gyro2"></block>
        <block type="xrobo_sensor_gyro3">
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">30</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_sensor_gyro4"></block>
        <block type="xrobo_sensor_gyro5">
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">30</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">870</field>
                </shadow>
            </value>
        </block>
    </category>

        <category name="%{BKY_XROBO_OUTPUT}" id="xrobo_output" colour="#7ED321" secondaryColour="#71BE1E" iconURI="${outputIcon}">
        <label text="%{BKY_XROBO_OUTPUT_LED}"></label>
        <block type="xrobo_led_1"></block>
        <block type="xrobo_led_2"></block>
        <block type="xrobo_led_3">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_led_4"></block>
        <block type="xrobo_led_5">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">5</field>
                </shadow>
            </value>
        </block>

        <label text="%{BKY_XROBO_OUTPUT_BUZZER}"></label>
        <block type="xrobo_buzzer_1"></block>
        <block type="xrobo_buzzer_2"></block>
        <block type="xrobo_buzzer_3"></block>
        <block type="xrobo_buzzer_4">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">262</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">200</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">250</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_buzzer_pitch_1">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_buzzer_pitch_2"></block>

        <label text="%{BKY_XROBO_OUTPUT_SERVO_MOTOR}"></label>
        <block type="xrobo_servo_1">
            <field name="ARG1">OUT1</field>
            <field name="ARG2">90</field>
        </block>
        <block type="xrobo_servo_2">
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">90</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_servo_3"></block>
        <block type="xrobo_servo_4">
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">5</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">90</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_servo_5">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">90</field>
                </shadow>
            </value>
        </block>
    </category>

    <category name="DISPLAY" id="xrobo_display" colour="#F66725" secondaryColour="#F5540A" iconURI="${displayIcon}">

    <label text="%{BKY_XROBO_DISPLAY_DOT_MATRIX}"></label>
    <block type="xrobo_display_dot_1"></block>
    <block type="xrobo_display_dot_2">
        <value name="ARG1">
            <shadow type="math_number"><field name="NUM">1</field></shadow>
        </value>
    </block>
    <block type="xrobo_display_dot_3">
        <value name="ARG1"><shadow type="math_number"><field name="NUM">1</field></shadow></value>
        <value name="ARG2"><shadow type="math_number"><field name="NUM">1</field></shadow></value>
    </block>
    <block type="xrobo_display_dot_4">
        <value name="ARG1"><shadow type="math_number"><field name="NUM">1</field></shadow></value>
    </block>
    <block type="xrobo_display_dot_5">
        <value name="ARG1"><shadow type="text"><field name="TEXT">AB</field></shadow></value>
    </block>
    <block type="xrobo_display_dot_6">
        <value name="ARG1"><shadow type="text"><field name="TEXT">ABC</field></shadow></value>
        <value name="ARG2"><shadow type="math_number"><field name="NUM">100</field></shadow></value>
        <value name="ARG3"><shadow type="math_number"><field name="NUM">1</field></shadow></value>
    </block>
    <block type="xrobo_display_dot_7">
        <value name="MATRIX">
            <shadow type="matrix">
                <field name="MATRIX">0101010101010101010101010101010101010101010101010101010101010101</field>
            </shadow>
        </value>
    </block>
    <block type="xrobo_display_dot_8">
        <value name="MATRIX">
            <shadow type="matrix">
                <field name="MATRIX">0101010101010101010101010101010101010101010101010101010101010101</field>
            </shadow>
        </value>
        <value name="MATRIX2">
            <shadow type="matrix2">
                <field name="MATRIX">11111111</field>
            </shadow>
        </value>
    </block>
    <block type="xrobo_display_dot_9"></block>
    <block type="xrobo_display_dot_10"></block>
    <block type="xrobo_display_dot_11"></block>

    <label text="%{BKY_XROBO_DISPLAY_FND}"></label>
    <block type="xrobo_fnd_1"></block>
    <block type="xrobo_fnd_2">
        <value name="ARG1"><shadow type="math_number"><field name="NUM">1234</field></shadow></value>
    </block>
    <block type="xrobo_fnd_3">
        <value name="ARG1"><shadow type="math_number"><field name="NUM">12</field></shadow></value>
        <value name="ARG2"><shadow type="math_number"><field name="NUM">30</field></shadow></value>
    </block>
    <block type="xrobo_fnd_4"></block>
    <block type="xrobo_fnd_5"></block>
    <block type="xrobo_fnd_6"></block>
    <block type="xrobo_fnd_7">
        <value name="ARG5"><shadow type="math_number"><field name="NUM">180</field></shadow></value>
    </block>
    <block type="xrobo_fnd_8"></block>
    <block type="xrobo_fnd_9"></block>

    <label text="%{BKY_XROBO_DISPLAY_GAME}"></label>
    <block type="xrobo_game_1"></block>
    <block type="xrobo_game_2"></block>
    <block type="xrobo_game_3"></block>
    <block type="xrobo_game_4">
        <value name="ARG5"><shadow type="math_number"><field name="NUM">1</field></shadow></value>
    </block>
    <block type="xrobo_game_5">
        <value name="ARG3"><shadow type="math_number"><field name="NUM">1</field></shadow></value>
    </block>

</category>

    <category name="%{BKY_XROBO_MOTOR}" id="xrobo_motor" colour="#FFD740" secondaryColour="#FFD020" iconURI="${motorIcon}">
        <label text="${isKoreanLocale(locale) ? '모터 1,2' : 'Motor 1,2'}"></label>
        <block type="xrobo_motor_12_1">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">500</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_motor_12_2"></block>
        <block type="xrobo_motor_12_3">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_motor_12_4"></block>
        <label text="${isKoreanLocale(locale) ? '모터 3,4' : 'Motor 3,4'}"></label>
        <block type="xrobo_motor_34_1">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">500</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_motor_34_2"></block>
        <block type="xrobo_motor_34_3">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_motor_34_4"></block>
        <label text="${isKoreanLocale(locale) ? '모터 N' : 'Motor N'}"></label>
        <block type="xrobo_motor_n_1">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_motor_n_2"></block>
        <block type="xrobo_motor_n_3">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">500</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_motor_n_4"></block>
        <block type="xrobo_motor_n_5">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">5</field>
                </shadow>
            </value>
        </block>
    </category>

    <category name="%{BKY_XROBO_RF}" id="xrobo_rf" colour="#AB47BC" secondaryColour="#9B3EAB" iconURI="${rfIcon}">
        <block type="xrobo_rf_set_1"></block>
        <block type="xrobo_rf_make_1">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG4">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG5">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG6">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_rf_set_2">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_rf_open"></block>
        <block type="xrobo_rf_wearable"></block>
        <block type="xrobo_rf_send_number">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_rf_send_string">
            <value name="ARG1">
                <shadow type="text">
                    <field name="TEXT">ok</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_rf_remote_data_1"></block>
        <block type="xrobo_rf_remote_data_2"></block>
        <block type="xrobo_rf_remote_data_3">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="xrobo_rf_remote_data_4">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG3">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="ARG4">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
    </category>

    <category name="%{BKY_XROBO_SERIAL}" id="xrobo_serial" colour="#0AAD80" secondaryColour="#099C73" iconURI="${serialIcon}">
        <block type="xrobo_serial_begin"></block>
        <block type="xrobo_serial_send_number">
            <value name="ARG1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
    </category>

    <category name="%{BKY_XROBO_EVENT}" id="xrobo_event" colour="#FFBF00" secondaryColour="#E6AC00" iconURI="${eventIcon}">

    <block type="xrobo_start"></block>

    <label text="%{BKY_XROBO_EVENT_TIMER}"></label>
    <block type="xrobo_reset_timer"></block>
    <block type="xrobo_get_seconds"></block>
    <block type="xrobo_get_milliseconds"></block>

</category>
    `;
